import { ContentGroup, Grid, GridItem, Paragraph, Text, } from '@imported/constellation';
import { Positive, Warning } from '@imported/constellation/icons/index.js';
import React from 'react';
import { useLabelContext } from '../../context/LabelContext.js';
import { VerticalSpace } from '../FormFields/index.js';
import { CommonFormStyleWrapper } from '../FormFields/styles.js';
import Navigation from '../Navigation/index.js';
import { BadImageWrapper, GoodImageWrapper, ListWrapper, SelfieImageWrapper, WarningIconWrapper, } from './styles.js';
const TakeSelfieContentForm = ({ handleTakePhotoContentSubmission, handlePreviousPage, description, imageUrl, }) => {
    const { getLabelFromContext } = useLabelContext();
    return (React.createElement(CommonFormStyleWrapper, null,
        React.createElement(Grid, null,
            React.createElement(GridItem, null,
                React.createElement(ContentGroup, null,
                    description?.map((el, index) => (React.createElement(ListWrapper, { key: el },
                        React.createElement(Text, null, `${index + 1}.`),
                        React.createElement(Paragraph, null, el)))),
                    React.createElement(VerticalSpace, { space: 24 }),
                    React.createElement(Text, { weight: 'bold' }, getLabelFromContext('components.takePhotoContent.example')),
                    React.createElement(VerticalSpace, { space: 12 }),
                    React.createElement(SelfieImageWrapper, null,
                        React.createElement(Grid, null,
                            React.createElement(GridItem, { md: 4, sm: 4 },
                                React.createElement(GoodImageWrapper, null,
                                    React.createElement("img", { alt: 'passport-success', src: imageUrl[0] }),
                                    React.createElement("div", null,
                                        React.createElement("span", null,
                                            React.createElement(Positive, { color: 'default1', iconSize: 'md' }),
                                            ' '),
                                        React.createElement(Text, null, getLabelFromContext('components.takeSelfieContentForm.goodPhoto'))))),
                            React.createElement(GridItem, { md: 4, sm: 4 },
                                React.createElement(BadImageWrapper, null,
                                    React.createElement("img", { alt: 'passport-bad', src: imageUrl[1] }),
                                    React.createElement("div", null,
                                        React.createElement(WarningIconWrapper, null,
                                            React.createElement(Warning, { color: 'critical', size: 's4' }),
                                            ' '),
                                        React.createElement(Text, null, getLabelFromContext('components.takeSelfieContentForm.badPhoto'))))))),
                    React.createElement(VerticalSpace, { space: 40 }),
                    React.createElement(Navigation, { previousLabel: getLabelFromContext('components.takeSelfieContentForm.navigation.previousLabel'), submitLabel: getLabelFromContext('components.takeSelfieContentForm.navigation.submitLabel'), handleNext: handleTakePhotoContentSubmission, handlePrevious: handlePreviousPage }))))));
};
export default TakeSelfieContentForm;
//# sourceMappingURL=index.js.map